export default "__VITE_ASSET__CIxQ9Suw__"